import { Pipe, PipeTransform } from '@angular/core';
import { TimeSlot } from '@checkout/const';

@Pipe({
  name: 'nextNHours',
  standalone: false,
})
export class NextNHours implements PipeTransform {
  transform(timeSlots: TimeSlot[]): string {
    const hoursHelper = (hour: number): string => {
      const lastSubstr = ('' + hour).slice(-1);

      return lastSubstr === '1' ? 'час' : +lastSubstr <= 4 && +lastSubstr !== 0 ? 'часа' : 'часов';
    };

    const length = timeSlots.map((timeSlot) => {
      const arr = timeSlot.interval.split(':');

      return +arr[1].slice(-2) - +arr[0];
    });

    return `Привезем за ${length[0]} ${hoursHelper(length[0])}`;
  }
}
